import {Stack, styled} from '@mui/material';

const Container = styled(Stack)`
	padding: 16px;
	height: 100%;
	justify-content: center;
	align-items: center;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 32px;
	}
`;

export {Container};
